export enum AdminGenerateLinkStatus {
	ACTIVE = 'active',
	EXPIRED = 'expired',
	INACTIVE = 'inactive',
	SCHEDULED = 'scheduled',
	ALL ='all'
}